<template>
  <div class="content-main">
    <div class="row">
      <div class="col-lg-12">
        <div class="section-title-index">
          <h2>Mapa de Desempenho</h2>
        </div>
      </div>

      <div class="col-lg-4 col-md-12">
        <div class="form-group">
          <vue-select
            id="quadrimestre"
            name="quadrimestre"
            :options="quadrimestres"
            label="quadrimestre"
            placeholder="QUADRIMESTRE"
            @input="onChangeQuadrimestre"
            class="grafico-select"
            v-model="quadrimestre"
          >
            <div slot="no-options">Não há opções correspondentes</div>
          </vue-select>
        </div>
      </div>
      <div class="col-lg-4 col-12">
        <vue-select
          :options="regions"
          label="label"
          placeholder="REGIÃO"
          @input="onChangeRegions"
          class="grafico-select"
          :disabled="disabelRegions"
          v-model="region"
        >
          <div slot="no-options">Não há opções correspondentes</div>
        </vue-select>
      </div>
      <div class="col-lg-4 col-12">
        <vue-select
          :options="states"
          label="uf"
          placeholder="UF"
          @input="onChangeStates"
          class="grafico-select"
          :disabled="disableStates"
          v-model="state"
        >
          <div slot="no-options">Não há opções correspondentes</div>
        </vue-select>
      </div>
      <div class="col-lg-4 col-12">
        <vue-select
          multiple
          :options="macroRegions"
          label="uf"
          placeholder="MACRO REGIÃO"
          @input="onChangeMacroRegion"
          class="grafico-select"
          :disabled="disableMacroRegion"
          v-model="macroRegion"
        >
          <div slot="no-options">Não há opções correspondentes</div>
        </vue-select>
      </div>
      <div class="col-lg-4 col-12">
        <vue-select
          multiple
          :options="regional"
          label="REGIONAL"
          placeholder="REGIONAL"
          @input="onChangeRegional"
          class="grafico-select"
          :disabled="disableRegional"
          v-model="regionalValue"
        >
          <div slot="no-options">Não há opções correspondentes</div>
        </vue-select>
      </div>
      <div class="col-lg-4 col-12">
        <vue-select
          :options="indicadores"
          label="label"
          placeholder="Indicadores"
          class="grafico-select"
          :disabled="disableIndicador"
          v-model="indicador"
          @input="onChangeIndicador"
        >
          <div slot="no-options">Não há opções correspondentes</div>
        </vue-select>
      </div>

      <div class="col-12 mapa">
        <l-map
          :zoom.sync="zoom"
          :center="center"
          style="height: 500px; width: 100%"
          ref="map"
          :options="{ zoomControl: false }"
        >
          <l-tile-layer :url="url" :attribution="attribution" />
          <l-control-zoom position="bottomright"></l-control-zoom>
          <template v-for="item in dados">
            <div
              v-if="
                (item.status == '0' || item.status == null) && comEsus === false
              "
              :key="item.key"
            >
              <l-circle-marker
                :lat-lng="[item.latitude, item.longitude]"
                :radius="10"
                :color="
                  getColor(
                    indicador === '' ? item.isf : `${item[indicador.value]}`
                  )
                "
                :fillColor="
                  getColor(
                    indicador === '' ? item.isf : `${item[indicador.value]}`
                  )
                "
                :stroke="false"
                :fillOpacity="0.6"
              >
                <l-tooltip>
                  <div class="tooltip-latlgn">
                    <strong>{{ item.no_municipio }} - {{ item.no_uf }}</strong>
                    <br />
                    <span v-if="indicador === '' || indicador.value === 'isf'">
                      ISF: <strong> {{ `${item.isf}` }}</strong>
                    </span>
                    <span v-else>
                      {{ indicador.title }}
                    </span>
                    <br />
                    {{ getIndicadorLabel() }}:
                    <strong>{{ getIndicadorValor(item) }} </strong>
                  </div>
                </l-tooltip>
              </l-circle-marker>
            </div>
            <div v-else-if="item.status == '1'" :key="item.key">
              <l-circle-marker
                v-if="comEsus === false"
                :lat-lng="[item.latitude, item.longitude]"
                :radius="10"
                :color="
                  getColor(
                    indicador === '' ? item.isf : `${item[indicador.value]}`
                  )
                "
                :fillColor="
                  getColor(
                    indicador === '' ? item.isf : `${item[indicador.value]}`
                  )
                "
                :stroke="false"
                :fillOpacity="0.6"
              >
                <l-tooltip>
                  <div class="tooltip-latlgn">
                    <strong>{{ item.no_municipio }} - {{ item.no_uf }}</strong>
                    <br />
                    <span v-if="indicador === '' || indicador.value === 'isf'">
                      ISF: <strong> {{ `${item.isf}` }}</strong>
                    </span>
                    <span v-else>
                      {{ indicador.title }}
                    </span>
                    <br />
                    {{ getIndicadorLabel() }}:
                    <strong>{{ getIndicadorValor(item) }} </strong>
                  </div>
                </l-tooltip>
              </l-circle-marker>
              <l-marker
                :lat-lng="[
                  `${item.latitude ? item.latitude : '0'}`,
                  `${item.longitude ? item.longitude : '0'}`,
                ]"
                :icon="icon"
              >
                <l-tooltip>
                  <div class="tooltip-latlgn">
                    <strong>{{ item.no_municipio }} - {{ item.no_uf }}</strong>
                    <br />
                    <span v-if="indicador === '' || indicador.value === 'isf'">
                      ISF: <strong> {{ `${item.isf}` }}</strong>
                    </span>
                    <span v-else>
                      {{ indicador.title }}
                    </span>
                    <br />
                    {{ getIndicadorLabel() }}:
                    <strong>{{ getIndicadorValor(item) }} </strong>
                  </div>
                </l-tooltip>
              </l-marker>
            </div>
          </template>
        </l-map>
      </div>
      <div class="col-12 col-sm-6 col-md-6 col-xl-6 col-lg-6">
        <div class="caption-map">
          <div class="caption-item caption-blue">
            <span></span>
            <h4>
              {{
                indicador !== ''
                  ? indicador.legend.blue
                  : indicadores[0].legend.blue
              }}
            </h4>
          </div>
          <div class="caption-item caption-green">
            <span></span>
            <h4>
              {{
                indicador !== ''
                  ? indicador.legend.green
                  : indicadores[0].legend.green
              }}
            </h4>
          </div>
          <div class="caption-item caption-orange">
            <span></span>
            <h4>
              {{
                indicador !== ''
                  ? indicador.legend.orange
                  : indicadores[0].legend.orange
              }}
            </h4>
          </div>
          <div class="caption-item caption-red">
            <span></span>
            <h4>
              {{
                indicador !== ''
                  ? indicador.legend.red
                  : indicadores[0].legend.red
              }}
            </h4>
          </div>
        </div>
      </div>
      <div
        class="d-flex justify-content-end col-12 col-sm-6 col-md-6 col-xl-6 col-lg-6"
      >
        <div class="form-check" style="margin-top: 7px">
          <input
            class="form-check-input"
            type="checkbox"
            v-model="comEsus"
            value=""
            id="flexCheckDefault"
          />
          <label class="form-check-label" for="flexCheckDefault">
            Com eSUS Feedback
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import {
  LMap,
  LTileLayer,
  LCircleMarker,
  LMarker,
  LIcon,
  LTooltip,
  LControlZoom,
} from 'vue2-leaflet'
import { latLng, icon } from 'leaflet'
import 'leaflet/dist/leaflet.css'
import VueSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import { coordinates } from './coordinates.js'
import { statesBR } from './states.js'

export default {
  name: 'mapaDesempenho',
  components: {
    PulseLoader,
    LMap,
    LTileLayer,
    LMarker,
    LIcon,
    LCircleMarker,
    LTooltip,
    LControlZoom,
    'vue-select': VueSelect,
  },
  data() {
    return {
      comEsus: false,
      steps: '',
      zoom: 5,
      center: latLng(-15.2, -51.31),
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      icon: icon({
        iconUrl: require('@/assets/icones/iconemapa2.png'),
        iconSize: [32, 37],
        iconAnchor: [16, 37],
      }),
      staticAnchor: [16, 37],
      customText: 'Foobar',
      iconSize: 64,

      regions: [
        {
          value: 'sul',
          label: 'Sul',
        },
        {
          value: 'sudeste',
          label: 'Sudeste',
        },
        {
          value: 'norte',
          label: 'Norte',
        },
        {
          value: 'nordeste',
          label: 'Nordeste',
        },
        {
          value: 'centro-oeste',
          label: 'Centro-Oeste',
        },
      ],
      disableIndicador: true,
      indicador: '',
      indicadores: [
        {
          value: 'isf',
          label: 'ISF',
          title: 'isf',
          regra: {
            red: 4.0,
            orange: {
              min: 3.9,
              max: 7.0,
            },
            green: {
              min: 6.9,
              max: 10,
            },
          },
          legend: {
            blue: 'ISF = 10',
            green: 'ISF > 6,9 e < 10',
            orange: 'ISF > 3,9 e < 7',
            red: 'ISF < 4',
          },
        },
        {
          value: 'pn_6_consultas',
          label: 'Consultas Pré-natal',
          title: 'CONSULTAS PRÉ-NATAL',
          regra: {
            red: 24,
            orange: {
              min: 24,
              max: 42,
            },
            green: {
              min: 42,
              max: 45,
            },
          },
          legend: {
            blue: '> 45%',
            green: '>= 42% e <= 45%',
            orange: '>= 24% e < 42%',
            red: '< 24%',
          },
        },
        {
          value: 'pn_hiv_sifilis',
          label: 'Exames HIV e Sífilis',
          title: 'HIV E SÍFILIS',
          regra: {
            red: 24,
            orange: {
              min: 24,
              max: 42,
            },
            green: {
              min: 42,
              max: 60,
            },
          },
          legend: {
            blue: '> 60%',
            green: '>= 42% e <= 60%',
            orange: '>= 24% e < 42%',
            red: '< 24',
          },
        },
        {
          value: 'pn_odontologia',
          label: 'Atendimento Odonto',
          title: 'ODONTOLOGIA',
          regra: {
            red: 24,
            orange: {
              min: 24,
              max: 42,
            },
            green: {
              min: 42,
              max: 60,
            },
          },
          legend: {
            blue: '> 60%',
            green: '>= 42% e <= 60%',
            orange: '>= 24% e < 42%',
            red: '< 24',
          },
        },
        {
          value: 'citopatologico',
          label: 'Exames Citopatológicos',
          title: 'CITOPATOLÓGICOS',
          regra: {
            red: 16,
            orange: {
              min: 16,
              max: 28,
            },
            green: {
              min: 28,
              max: 40,
            },
          },
          legend: {
            blue: '> 40%',
            green: '>= 28% e <= 40%',
            orange: '>= 16% e < 28%',
            red: '< 16%',
          },
        },
        {
          value: 'crianca_polio_penta',
          label: 'Vacinação',
          title: 'PÓLIO E PENTA',
          regra: {
            red: 38,
            orange: {
              min: 38,
              max: 66,
            },
            green: {
              min: 66,
              max: 95,
            },
          },
          legend: {
            blue: '> 95%',
            green: '>= 66% e <= 95%',
            orange: '>= 38% e < 66%',
            red: '< 38%',
          },
        },
        {
          value: 'pa_hipertensao',
          label: 'Hipertensos',
          title: 'HIPERTENSOS',
          regra: {
            red: 20,
            orange: {
              min: 20,
              max: 35,
            },
            green: {
              min: 35,
              max: 50,
            },
          },
          legend: {
            blue: '> 50%',
            green: '>= 35% e <= 50%',
            orange: '>= 20% e < 35%',
            red: '< 20%',
          },
        },
        {
          value: 'hg_diabetes',
          label: 'Diabéticos',
          title: 'DIABÉTICOS',
          regra: {
            red: 20,
            orange: {
              min: 20,
              max: 35,
            },
            green: {
              min: 35,
              max: 50,
            },
          },
          legend: {
            blue: '> 50%',
            green: '>= 35% e <= 50%',
            orange: '>= 20% e < 35%',
            red: '< 20%',
          },
        },
      ],

      region: [],
      population: [],
      populations: [
        {
          value: 'de 50.001 a 100.000',
          label: 'de 50.001 a 100.000',
        },
        {
          value: 'de 5.001 a 10.000',
          label: 'de 5.001 a 10.000',
        },
        {
          value: 'de 20.001 a 50.000',
          label: 'de 20.001 a 50.000',
        },
        {
          value: 'de 100.001 a 500.000',
          label: 'de 100.001 a 500.000',
        },
        {
          value: 'de 10.001 a 20.000',
          label: 'de 10.001 a 20.000',
        },
        {
          value: 'até 5.000',
          label: 'até 5.000',
        },
        {
          value: 'acima de 500.000 hab.',
          label: 'acima de 500.000 hab.',
        },
      ],
      dataIsf: [
        {
          value: 'ISF < 4,0',
          label: 'ISF < 4,0',
        },
        {
          value: 'ISF > 3,9 e < 7,0',
          label: 'ISF > 3,9 e < 7,0',
        },
        {
          value: 'ISF > 6,9 e < 10,0',
          label: 'ISF > 6,9 e < 10,0',
        },
        {
          value: 'ISF  = 10,0',
          label: 'ISF = 10,0',
        },
      ],
      state: '',
      states: [],
      /*     states: [...statesBR], */
      macroRegion: [],
      macroRegions: [],
      regional: [],
      regionalValue: '',
      isf: [],
      markersFilter: [],
      dataToFilter: [],
      disabelRegions: true,
      disableStates: true,
      disablePopulation: false,
      disableMacroRegion: true,
      disableRegional: true,
      disableIsf: true,
      dataFilterCitiesRegion: [],
      dataFilterPopulation: [],
      dataFilterMacroRegions: [],
      dataFilterRegional: [],
      dataFilterIsf: [],
      info: {
        type: 'municipio',
        title:
          'Os primeiros da lista são municípios com melhor desempenho, ou seja, ISF mais alto.',
      },
      dados: [],
      dadosOriginaisDaRequisicao: [],
      nomeMunicipio: '',
      loading: false,
      loadingPdf: false,
      municipio: '',
      quadrimestre: '',
      quadrimestres: [],
      temEstadoSelecionado: false,
      size: '40px',
      color: '#0D98BB',
      openedModal: false,
      openedModalSeloAps: false,
      openedModalPorcentagem: false,
      seloApsImg: '',
      porcentagemImg: '',
    }
  },
  computed: {
    dynamicSize() {
      return [this.iconSize, this.iconSize * 1.15]
    },
    dynamicAnchor() {
      return [this.iconSize / 2, this.iconSize * 1.15]
    },
  },
  async mounted() {
    this.setIndicadorInitial()
    await this.buscarQuadrimestres()
  },
  methods: {
    getCoordinates() {
      setTimeout(() => {
        // pega as coordenadas do estado
        const stateCoordinates = coordinates.find((item) => {
          return item.uf === this.state
        })
        const mapObject = this.$refs.map.mapObject
        mapObject.setView(
          latLng(stateCoordinates.lat, stateCoordinates.lgn),
          stateCoordinates.zoom
        )
      }, 500)
    },
    setIndicadorInitial() {
      this.indicador = this.indicadores[0]
    },
    onChangeIndicador(event) {
      this.comEsus = false
      if (event !== null) {
        // pega as coordenadas do estado
        this.getCoordinates()
      } else {
        this.setIndicadorInitial()

        // pega as coordenadas do estado
        this.getCoordinates()
      }
    },
    getIndicadorValor(item) {
      if (this.indicador === '' || this.indicador.value === 'isf') {
        return item.desempenho
      } else {
        if (this.indicador.value === 'pn_6_consultas') {
          return item[this.indicador.value] + ' %'
        } else {
          return item[this.indicador.value]
        }
      }
    },
    getIndicadorLabel() {
      if (this.indicador === '' || this.indicador.value === 'isf') {
        return 'DESEMPENHO'
      } else {
        return 'RESULTADO'
      }
    },
    trDinamica() {
      if (this.steps === 'regiao') {
        return 'Região'
      }
      if (this.steps === 'estado') {
        return 'UF'
      }
      if (this.steps === 'macroRegiao') {
        return 'Macro Região'
      }
      if (this.steps === 'regional') {
        return 'Regional'
      }
      if (this.steps === 'populacao') {
        return 'População'
      }
    },
    tdDinamica() {
      if (this.steps === 'regiao') {
        return this.region.label.replace('-', ' ')
      }
      if (this.steps === 'estado') {
        return this.state
      }
      if (this.steps === 'macroRegiao') {
        return this.macroRegion
      }
      if (this.steps === 'regional') {
        return this.regionalValue
      }
      if (this.steps === 'populacao') {
        return this.population.value
      }
    },
    filter(
      dataFilterCitiesRegion,
      dataFilterPopulation,
      dataFilterMacroRegions,
      dataFilterRegional
    ) {
      let data = []
      data = this.dadosOriginaisDaRequisicao
      // Busca todas cidades da região
      if (dataFilterCitiesRegion.length > 0) {
        data = this.allCitiesInRegion(dataFilterCitiesRegion)
      }

      // busca todas as cidades do estado

      if (this.state !== '') {
        data = this.allCitiesByState(this.state)
      }

      // filtra por população
      if (dataFilterPopulation.length > 0) {
        data = this.citiesByPopulation(dataFilterPopulation)
      }

      // filtra por macro região
      if (dataFilterMacroRegions.length > 0) {
        data = this.citiesByMacroRegions(
          data,
          this.state,
          dataFilterMacroRegions
        )
      }

      // filtra por regional
      if (dataFilterRegional.length > 0) {
        data = this.citiesByRegional(data, this.state, dataFilterRegional)
      }

      // Tira os dados sem localização
      data = data.filter((item) => {
        return (
          item.latitude != '0' &&
          item.latitude != null &&
          item.longitude != '0' &&
          item.longitude != null
        )
      })

      this.dados = data
    },
    async onChangeQuadrimestre(event) {
      this.dados = []
      this.dadosOriginaisDaRequisicao = []
      this.setIndicadorInitial()
      this.disableIndicador = true
      this.comEsus = false
      if (event !== null) {
        this.quadrimestre = event.quadrimestre
        this.disabelRegions = false
        this.region = ''
        this.state = ''
        this.states = []
        this.macroRegions = []
        this.population = []
        this.dataFilterCitiesRegion = ''
        this.dataFilterMacroRegions = []
        this.dataFilterPopulation = []
        this.dataFilterRegional = []

        // Disabled
        this.disableStates = true
        this.disableMacroRegion = true
        this.disableRegional = true
      } else {
        this.quadrimestre = ''
        this.region = ''
        this.steps = ''
        this.state = ''
        this.states = []
        this.macroRegions = []
        this.population = []
        this.dataFilterCitiesRegion = ''
        this.dataFilterMacroRegions = []
        this.dataFilterPopulation = []
        this.dataFilterRegional = []

        // Disabled
        this.disabelRegions = true
        this.disableStates = true
        this.disableMacroRegion = true
        this.disableRegional = true
      }
    },
    onChangeRegions(event) {
      this.dados = []
      this.dadosOriginaisDaRequisicao = []
      // Resetar Indicador
      this.setIndicadorInitial()
      this.disableIndicador = true
      this.comEsus = false
      if (event !== null) {
        this.steps = 'regiao'
        this.disableStates = false
        this.state = ''
        this.states = []
        this.macroRegions = []
        this.population = []
        this.dataFilterCitiesRegion = ''
        this.dataFilterMacroRegions = []
        this.dataFilterPopulation = []
        this.dataFilterRegional = []

        this.region = event
        const dataUf = []
        dataUf.push(event.value)

        const data = statesBR.filter((item) => {
          return dataUf.includes(item.region)
        })

        this.states = data
        this.dataFilterCitiesRegion = data.map((element) => {
          return element.uf
        })
      } else {
        this.steps = ''
        this.state = ''
        this.states = []
        this.macroRegions = []
        this.population = []
        this.dataFilterCitiesRegion = ''
        this.dataFilterMacroRegions = []
        this.dataFilterPopulation = []
        this.dataFilterRegional = []

        this.dados = []
        this.dadosOriginaisDaRequisicao = []

        // Disabled
        this.disableStates = true
        this.disableMacroRegion = true
        this.disableRegional = true
      }
    },

    async onChangeStates(event) {
      this.steps = 'estado'
      this.dataFilterRegional = []
      this.regionalValue = ''
      this.disableRegional = true
      this.comEsus = false
      if (event !== null) {
        this.dataFilterMacroRegions = []
        this.dataFilterRegional = []
        this.macroRegion = []
        this.macroRegions = []
        this.population = []
        this.state = event.uf
        this.regional = []
        this.disableMacroRegion = false
        this.disableIndicador = false
        // Busca todos os dados
        await this.allCities()

        // pega as coordenadas do estado
        this.getCoordinates()

        // busca as macro regiões do estado
        this.allMacroRegionByState(this.state)
        this.filter(
          this.dataFilterCitiesRegion,
          this.dataFilterPopulation,
          this.dataFilterMacroRegions,
          this.dataFilterRegional
        )
      } else {
        this.steps = 'regiao'
        this.state = ''
        this.regional = []
        this.population = []
        this.macroRegion = []
        this.macroRegions = []
        this.dataFilterMacroRegions = []
        this.dataFilterPopulation = []
        this.dataFilterRegional = []

        this.dados = []
        this.dadosOriginaisDaRequisicao = []

        // Resetar Indicador
        this.setIndicadorInitial()

        // Disabled
        this.disableMacroRegion = true
        this.disableIndicador = true
        this.filter(
          this.dataFilterCitiesRegion,
          this.dataFilterPopulation,
          this.dataFilterMacroRegions,
          this.dataFilterRegional
        )
      }
    },

    onChangePopulations(event) {
      // Disabled
      this.disableStates = true
      this.disableMacroRegion = true
      this.disableRegional = true
      this.dataFilterRegional = []
      this.regionalValue = ''

      this.dados = []
      this.dadosOriginaisDaRequisicao = []
      this.comEsus = false
      if (event !== null) {
        this.steps = 'populacao'
        const dataFilterPopulation = []

        dataFilterPopulation.push(event.value)

        this.dataFilterPopulation = dataFilterPopulation

        // Limpas os outros campos
        this.state = ''
        this.states = []
        this.region = []
        this.regional = []
        this.macroRegion = []
        this.macroRegions = []
        this.dataFilterCitiesRegion = []
        this.dataFilterMacroRegions = []
        this.dataFilterRegional = []

        this.filter(
          this.dataFilterCitiesRegion,
          this.dataFilterPopulation,
          this.dataFilterMacroRegions,
          this.dataFilterRegional
        )
      } else {
        this.steps = ''
        this.population = []
        this.dataFilterPopulation = []
        this.filter(
          this.dataFilterCitiesRegion,
          this.dataFilterPopulation,
          this.dataFilterMacroRegions,
          this.dataFilterRegional
        )
      }
    },

    onChangeMacroRegion(event) {
      this.steps = 'macroRegiao'
      this.dataFilterRegional = []
      this.regionalValue = ''
      this.comEsus = false
      if (event.length > 0) {
        const dataFilterMacroRegions = []
        event.forEach((element) => {
          dataFilterMacroRegions.push(element)
        })
        dataFilterMacroRegions.push(event)
        this.dataFilterMacroRegions = dataFilterMacroRegions

        // busca as regiões do estado
        this.allRegionalByState(this.state, this.dataFilterMacroRegions)
        this.disableMacroRegion = false
        this.disableRegional = false
        this.filter(
          this.dataFilterCitiesRegion,
          this.dataFilterPopulation,
          this.dataFilterMacroRegions,
          this.dataFilterRegional
        )
      } else {
        this.steps = 'estado'
        this.macroRegion = []
        this.disableRegional = true
        this.dataFilterMacroRegions = []
        this.filter(
          this.dataFilterCitiesRegion,
          this.dataFilterPopulation,
          this.dataFilterMacroRegions,
          this.dataFilterRegional
        )
      }
    },

    onChangeRegional(event) {
      this.comEsus = false
      if (event.length > 0) {
        this.steps = 'regional'
        const dataFilterRegional = []
        event.forEach((element) => {
          dataFilterRegional.push(element)
        })
        this.dataFilterRegional = dataFilterRegional
        this.filter(
          this.dataFilterCitiesRegion,
          this.dataFilterPopulation,
          this.dataFilterMacroRegions,
          this.dataFilterRegional
        )
      } else {
        this.steps = 'macroRegiao'
        this.regionalValue = ''
        this.dataFilterRegional = []
        this.filter(
          this.dataFilterCitiesRegion,
          this.dataFilterPopulation,
          this.dataFilterMacroRegions,
          this.dataFilterRegional
        )
      }
    },
    async allCities() {
      try {
        this.loading = true
        let url = `previne-brasil/ranking/regional/${this.region.label}/${this.quadrimestre}`

        let response = await this.$apiPublic.get(url)
        if (response) {
          this.dados = response.data
          this.dadosOriginaisDaRequisicao = response.data
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    // Buscas todos registros de todas cidades da região
    allCitiesInRegion(cities) {
      const allData = this.dadosOriginaisDaRequisicao

      const data = allData.filter((item) => {
        return cities.includes(item.no_uf)
      })

      // Passa a data e o limite de municipios
      return this.ordenando(data, 100)
    },

    // Ordena os regitros por isf e por desempenho
    ordenando(data, limit) {
      const ordenado = data.sort((a, b) => {
        if (Number(a.isf) === Number(b.isf)) {
          if (Number(a.desempenho) < Number(b.desempenho)) return 1
          if (Number(a.desempenho) > Number(b.desempenho)) return -1
          return 0
        } else {
          if (Number(a.isf) < Number(b.isf)) return 1
          if (Number(a.isf) > Number(b.isf)) return -1
          return 0
        }
      })
      if (limit) {
        let ordenadoComLimit = []

        if (ordenado.length < limit) {
          for (let i = 0; i < ordenado.length; i++) {
            ordenadoComLimit.push(ordenado[i])
          }
        } else {
          for (let i = 0; i < limit; i++) {
            ordenadoComLimit.push(ordenado[i])
          }
        }
        return ordenadoComLimit
      } else {
        return ordenado
      }
    },

    // Busca todas cidades por estado
    allCitiesByState(uf) {
      const allData = this.dadosOriginaisDaRequisicao
      const data = allData.filter((item) => {
        return item.no_uf === uf
      })
      return data
    },
    // Busca todas cidades por macro região
    citiesByMacroRegions(data, uf, macroRegions) {
      const res = data.filter((item) => {
        return item.no_uf === uf && macroRegions.includes(item.no_macro_regiao)
      })
      return res
    },
    // Busca todas cidades por regional
    citiesByRegional(data, uf, regional) {
      const res = data.filter((item) => {
        return item.no_uf === uf && regional.includes(item.no_regiao_saude)
      })
      return res
    },

    citiesByPopulation(population) {
      const allData = this.allCities()
      const data = allData.filter((item) => {
        return population.includes(item.faixa_populacional)
      })
      // Passa a data e o limite de municipios
      return this.ordenando(data, 100)
    },

    // Popula o select macroRegions
    allMacroRegionByState(uf) {
      const allData = this.dadosOriginaisDaRequisicao
      const states = allData.filter((item) => {
        return item.no_uf === uf
      })
      const data = []
      states.forEach((element) => {
        data.push(element.no_macro_regiao)
      })
      // removendo valores duplicados
      const result = data
        .map((e) => JSON.stringify(e))
        .reduce((acc, cur) => (acc.includes(cur) || acc.push(cur), acc), [])
        .map((e) => JSON.parse(e))
      this.macroRegions = result
    },

    allRegionalByState(uf, macroRegiao) {
      const allData = this.dadosOriginaisDaRequisicao
      const states = allData.filter((item) => {
        return item.no_uf === uf && macroRegiao.includes(item.no_macro_regiao)
      })
      const data = []
      states.forEach((element) => {
        data.push(element.no_regiao_saude)
      })

      // removendo valores duplicados
      const result = data
        .map((e) => JSON.stringify(e))
        .reduce((acc, cur) => (acc.includes(cur) || acc.push(cur), acc), [])
        .map((e) => JSON.parse(e))

      this.regional = result.filter((item) => item !== null)
    },

    async buscarQuadrimestres() {
      try {
        this.loading = true

        let quadrimestres = await this.$apiPublic.get(
          '/serie-historica/indicadores-previne-brasil/quadrimestres'
        )
        if (quadrimestres) {
          this.quadrimestres = quadrimestres.data
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },

    /*
    Estilização
     *************************************************************
     *************************************************************
     *************************************************************
     *************************************************************
     *************************************************************
     *************************************************************
     *************************************************************
     *************************************************************
     *************************************************************
     *************************************************************
     *************************************************************
     *************************************************************
     */
    getRadius(desempenho) {
      const value = parseFloat(desempenho)
      const result = value / 30
      return result
    },
    getColor(isf) {
      const value = parseFloat(isf)
      const indicador = this.indicador

      switch (indicador.value) {
        case 'isf':
          if (value < indicador.regra.red) {
            return 'red'
          } else if (
            value > indicador.regra.orange.min &&
            value < indicador.regra.orange.max
          ) {
            return 'orange'
          } else if (
            value > indicador.regra.green.min &&
            value < indicador.regra.green.max
          ) {
            return 'green'
          } else {
            return 'blue'
          }
        default:
          if (value < indicador.regra.red) {
            return 'red'
          } else if (
            value >= indicador.regra.orange.min &&
            value < indicador.regra.orange.max
          ) {
            return 'orange'
          } else if (
            value >= indicador.regra.green.min &&
            value <= indicador.regra.green.max
          ) {
            return 'green'
          } else {
            return 'blue'
          }
      }
    },
    getIsfText(isf) {
      const value = parseFloat(isf)
      if (value < 4.0) {
        return 'ISF < 4,0'
      } else if (value > 3.9 && value < 7.0) {
        return 'ISF > 3,9 e < 7,0'
      } else if (value > 6.9 && value < 10) {
        return 'ISF > 6,9 e < 10,0'
      } else {
        return 'ISF - 10,0'
      }
    },
    updateInfo(info) {
      switch (info) {
        case 'serie-historica':
          this.info.type = 'serie-historica'
          this.info.title =
            'Gráfico com a série histórica dos indicadores atuais.'
          break
        case 'selo-aps':
          this.info.type = 'selo-aps'
          this.info.title =
            'Municípios que tem tem ISF >= 7 recebem certificado de APS de qualidade.'
          break
        case 'municipio':
          this.info.type = 'municipio'
          this.info.title =
            'Os primeiros da lista são municípios com melhor desempenho, ou seja, ISF mais alto.'
          break
        case 'pre-natal':
          this.info.type = 'pre-natal'
          this.info.title =
            'Proporção de gestantes com pelo menos 6 (seis) consultas pré-natal realizadas, sendo a primeira até a 12ª semana de gestação.'
          break
        case 'hiv-sifilis':
          this.info.type = 'hiv-sifilis'
          this.info.title =
            'Proporção de gestantes com realização de exames para sífilis e HIV.'
          break
        case 'consultas-odontologicas':
          this.info.type = 'consultas-odontologicas'
          this.info.title =
            'Proporção de gestantes com atendimento odontológico realizado.'
          break
        case 'citopatologico':
          this.info.type = 'citopatologico'
          this.info.title = 'Cobertura de exame citopatológico.'
          break
        case 'polio-penta':
          this.info.type = 'polio-penta'
          this.info.title =
            'Proporção de crianças de 1 (um) ano de idade vacinadas na APS contra Difteria, Tétano, Coqueluche, Hepatite B, infecções causadas por Haemophilus Influenzae tipo b e Poliomielite Inativada.'
          break
        case 'hipertensao':
          this.info.type = 'hipertensao'
          this.info.title =
            'Percentual de pessoas hipertensas com Pressão Arterial aferida em cada semestre.'
          break
        case 'hemoglobina-glicada':
          this.info.type = 'hemoglobina-glicada'
          this.info.title =
            'Percentual de diabéticos com solicitação de hemoglobina glicada.'
          break
        case 'isf':
          this.info.type = 'isf'
          this.info.title = 'Indicador Sintético Final.'
          break
        case 'desempenho':
          this.info.type = 'desempenho'
          this.info.title =
            'O desempenho é calculado pela média dos resultados individuais dos indicadores e ponderada pelos pesos de cada indicador multiplicada pelo ISF.'
          break
        default:
          break
      }
    },

    indicadorColor(percentual, indicador) {
      switch (indicador) {
        case 'pre-natal':
          if (percentual < 24) {
            return 'sh-ri-percent-red'
          } else if (percentual >= 24 && percentual <= 42) {
            return 'sh-ri-percent-orange'
          } else if (percentual > 42 && percentual <= 44) {
            return 'sh-ri-percent-green'
          } else {
            return 'sh-ri-percent-blue'
          }
          break
        case 'hiv-sifilis':
          if (percentual < 24) {
            return 'sh-ri-percent-red'
          } else if (percentual >= 24 && percentual <= 42) {
            return 'sh-ri-percent-orange'
          } else if (percentual > 42 && percentual <= 60) {
            return 'sh-ri-percent-green'
          } else {
            return 'sh-ri-percent-blue'
          }
          break
        case 'consultas-odontologicas':
          if (percentual < 24) {
            return 'sh-ri-percent-red'
          } else if (percentual >= 24 && percentual <= 42) {
            return 'sh-ri-percent-orange'
          } else if (percentual > 42 && percentual <= 60) {
            return 'sh-ri-percent-green'
          } else {
            return 'sh-ri-percent-blue'
          }
          break
        case 'citopatologico':
          if (percentual < 16) {
            return 'sh-ri-percent-red'
          } else if (percentual >= 16 && percentual <= 28) {
            return 'sh-ri-percent-orange'
          } else if (percentual > 28 && percentual <= 40) {
            return 'sh-ri-percent-green'
          } else {
            return 'sh-ri-percent-blue'
          }
          break
        case 'polio-penta':
          if (percentual < 38) {
            return 'sh-ri-percent-red'
          } else if (percentual >= 38 && percentual <= 66.5) {
            return 'sh-ri-percent-orange'
          } else if (percentual > 66.5 && percentual <= 95) {
            return 'sh-ri-percent-green'
          } else {
            return 'sh-ri-percent-blue'
          }
          break
        case 'hipertensao':
          if (percentual < 20) {
            return 'sh-ri-percent-red'
          } else if (percentual >= 20 && percentual <= 35) {
            return 'sh-ri-percent-orange'
          } else if (percentual > 35 && percentual <= 50) {
            return 'sh-ri-percent-green'
          } else {
            return 'sh-ri-percent-blue'
          }
          break
        case 'hemoglobina-glicada':
          if (percentual < 20) {
            return 'sh-ri-percent-red'
          } else if (percentual >= 20 && percentual <= 35) {
            return 'sh-ri-percent-orange'
          } else if (percentual > 35 && percentual <= 50) {
            return 'sh-ri-percent-green'
          } else {
            return 'sh-ri-percent-blue'
          }
          break
        default:
          break
      }
    },
    /*     async showModal(item) {
      this.$emit('closeMenu')
      this.openedModal = true
      this.municipio = item
      // limpa o gráfico inicialmente
      this.$refs.chartData.updateSeries([])
      try {
        let response = await this.$apiPublic.get(
          '/serie-historica/indicadores-previne-brasil/resultado/municipio/' +
            item.co_ibge
        )
        if (response) {
          let response2 = response.data
          let array_xaxis = []
          let array_chart_pre_natal = [],
            array_chart_hiv_sifilis = [],
            array_chart_consultas_odontologicas = [],
            array_chart_citologico = [],
            array_chart_imunizacao = [],
            array_chart_hipertensao = [],
            array_chart_hemoglobina = []

          //preencher a legenda
          for (const item of response2) {
            array_xaxis.push(item.quadrimestre)
          }

          for (let i = 0; i < array_xaxis.length; i++) {
            var eixo_x_atual = array_xaxis[i]
            for (const item of response2) {
              var resultado_pre_natal = 0
              var resultado_hiv_sifilis = 0
              var resultado_consultas_odontologicas = 0
              var resultado_citologico = 0
              var resultado_imunizacao = 0
              var resultado_hipertensao = 0
              var resultado_hemoglobina = 0
              if (item.quadrimestre == eixo_x_atual) {
                resultado_pre_natal = item.pn_6_consultas
                resultado_hiv_sifilis = item.pn_hiv_sifilis
                resultado_consultas_odontologicas = item.pn_odontologia
                resultado_citologico = item.citopatologico
                resultado_imunizacao = item.crianca_polio_penta
                resultado_hipertensao = item.pa_hipertensao
                resultado_hemoglobina = item.hg_diabetes
                break
              } else {
                resultado_pre_natal = null
                resultado_hiv_sifilis = null
                resultado_consultas_odontologicas = null
                resultado_citologico = null
                resultado_imunizacao = null
                resultado_hipertensao = null
                resultado_hemoglobina = null
              }
            }
            array_chart_pre_natal.push(resultado_pre_natal)
            array_chart_hiv_sifilis.push(resultado_hiv_sifilis)
            array_chart_consultas_odontologicas.push(
              resultado_consultas_odontologicas
            )
            array_chart_citologico.push(resultado_citologico)
            array_chart_imunizacao.push(resultado_imunizacao)
            array_chart_hipertensao.push(resultado_hipertensao)
            array_chart_hemoglobina.push(resultado_hemoglobina)
          }

          this.$refs.chartData.updateOptions({
            xaxis: {
              categories: array_xaxis
            },
            title: {
              text: `${item.municipio} - ${item.uf}`
            },
            subtitle: {
              text: `Indicadores do Previne Brasil. Fonte: eSUS Feedback, SISAB (${item.quadrimestre})`
            },
            yaxis: {
              min: 0,
              max: 100
            }
          })
          this.$refs.chartData.updateSeries([
            {
              name: 'Consultas pré-natal',
              data: array_chart_pre_natal
            },
            {
              name: 'Exames HIV e Sífilis',
              data: array_chart_hiv_sifilis
            },
            {
              name: 'Consultas odontológicas',
              data: array_chart_consultas_odontologicas
            },
            {
              name: 'Citopatológico',
              data: array_chart_citologico
            },
            {
              name: 'Vacinas',
              data: array_chart_imunizacao
            },
            {
              name: 'Hipertensão',
              data: array_chart_hipertensao
            },
            {
              name: 'Diabéticos',
              data: array_chart_hemoglobina
            }
          ])
        }
      } catch (error) {
        console.log(error)
      }
    },

    async showModalIsf(item) {
      this.$emit('closeMenu')
      this.openedModal = true
      this.municipio = item
      // limpa o gráfico inicialmente
      this.$refs.chartData.updateSeries([])
      try {
        let response = await this.$apiPublic.get(
          '/serie-historica/indicadores-previne-brasil/resultado/municipio/' +
            item.co_ibge
        )
        if (response) {
          let response2 = response.data
          let array_xaxis = []
          let array_chart_isf = []

          //preencher a legenda
          for (const item of response2) {
            array_xaxis.push(item.quadrimestre)
          }

          for (let i = 0; i < array_xaxis.length; i++) {
            var eixo_x_atual = array_xaxis[i]
            for (const item of response2) {
              var resultado_isf = 0
              if (item.quadrimestre == eixo_x_atual) {
                resultado_isf = item.isf
                break
              } else {
                resultado_isf = null
              }
            }
            array_chart_isf.push(resultado_isf)
          }

          this.$refs.chartData.updateOptions({
            xaxis: {
              categories: array_xaxis
            },
            title: {
              text: `${item.municipio} - ${item.uf}`
            },
            subtitle: {
              text: `Indicador Sintético Final. Fonte: eSUS Feedback, SISAB (${item.quadrimestre})`
            },
            yaxis: {
              min: 0,
              max: 10
            }
          })
          this.$refs.chartData.updateSeries([
            {
              name: 'ISF',
              data: array_chart_isf
            }
          ])
        }
      } catch (error) {
        console.log(error)
      }
    }, */

    /*  async buscarDados() {
      try {
        this.loading = true

        let quadrimestres = await this.$apiPublic.get(
          '/serie-historica/indicadores-previne-brasil/quadrimestres'
        )
        if (quadrimestres) {
          this.quadrimestres = quadrimestres.data
          this.quadrimestre = quadrimestres.data[0].quadrimestre
        }
        let response = await this.$apiPublic.get(
          '/serie-historica/indicadores-previne-brasil/resultado/quadrimestre/' +
            this.quadrimestre
        )
        if (response) {
          this.dados = response.data
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },*/

    /*    async buscarPorQuadrimestre(event) {
      this.quadrimestre = event.target.value
      try {
        this.loading = true
        let url = ''
        if (this.estado == '') {
          url =
            '/serie-historica/indicadores-previne-brasil/resultado/quadrimestre/' +
            this.quadrimestre
        } else {
          url =
            '/serie-historica/indicadores-previne-brasil/resultado/estado/' +
            this.estado +
            '/quadrimestre/' +
            this.quadrimestre
        }
        let response = await this.$apiPublic.get(url)
        if (response) {
          this.dados = response.data
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    }, */

    /*   async buscarPorEstado(event) {
      this.estado = event.target.value
      this.temEstadoSelecionado = true
      try {
        this.loading = true
        let url = ''
        if (this.quadrimestre == '') {
          url =
            '/serie-historica/indicadores-previne-brasil/resultado/estado/' +
            this.estado
        } else {
          url =
            '/serie-historica/indicadores-previne-brasil/resultado/estado/' +
            this.estado +
            '/quadrimestre/' +
            this.quadrimestre
        }
        let response = await this.$apiPublic.get(url)
        if (response) {
          this.dados = response.data
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    }, */

    /*     downloadSeloAps(seloApsImg) {
      window.open(`${seloApsImg}&download=true`, '_blank')
    },

    downloadImgPorcentagem(porcentagemImg) {
      window.open(`${porcentagemImg}&download=true`, '_blank')
    }, */

    /*     resetarFiltros() {
      this.estado = ''
      this.nomeMunicipio = ''
      this.temEstadoSelecionado = false
      this.buscarDados()
    }, */

    changeFontColor(isf) {
      if (isf < 4) {
        return 'sh-re-button-isf-red'
      } else if (isf >= 4 && isf < 7) {
        return 'sh-re-button-isf-orange'
      } else if (isf >= 7 && isf <= 9) {
        return 'sh-re-button-isf-green'
      } else if (isf > 9) {
        return 'sh-re-button-isf-blue'
      } else {
        return ''
      }
    },
  },
}
</script>

<style>
.leaflet-container {
  z-index: 5;
}

.grafico-select {
  margin-bottom: 15px;
  background-color: #fff;
}

.caption-map {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  margin-top: 10px;
}

.caption-item {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 5px;
}

.caption-item span {
  width: 15px;
  height: 15px;
  border-radius: 30px;
}

.caption-item h4 {
  font-size: 16px;
  margin: 0;
}

.caption-item.caption-blue span {
  background-color: blue;
}

.caption-item.caption-green span {
  background-color: green;
}

.caption-item.caption-orange span {
  background-color: orange;
}

.caption-item.caption-red span {
  background-color: red;
}
@media screen and (max-width: 656px) {
  .caption-map {
    justify-content: center !important;
  }
  .caption-item {
    flex-direction: column !important;
    text-align: center !important;
  }

  .caption-item h4 {
    font-size: 9px !important;
  }
}
@media screen and (min-width: 657px) and (max-width: 807px) {
}
@media screen and (min-width: 808px) and (max-width: 1023px) {
}
@media screen and (min-width: 1024px) and (max-width: 1265px) {
}
</style>
<style scoped>
.mapa {
  z-index: 0;
}
.tooltip-latlgn img {
  width: 20px;
}
</style>
